import styled from "styled-components";
import { Flex } from "grid-styled";

export const GrayBox = styled(Flex)`
  flex-shrink: 0;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.large};
  background-color: ${({ theme: { palette } }) => palette.elementDark};
  height: 1.75rem;
  width: ${({ width }) => width || "14rem"};
`;

const Shape = styled(Flex)`
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  background-color: ${({ theme: { palette } }) => palette.elementDark};
`;

export const Circle = styled(Shape)`
  display: inline-flex;
  border-radius: 50%;
`;
